/* eslint-disable consistent-return */
/* eslint-disable no-console */
import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import RegisterStatusCard from 'components/molecules/register_status_card';
import { useDispatch, useSelector } from 'react-redux';
import tabId from 'services/tabId';
import { ApplicationState } from 'store';
import { RegisterState } from 'store/modules/register_store/types';
import { userExists } from 'store/modules/register_store/actions';
import { profileSignIn } from 'store/modules/profile_store/actions';

const TIMEOUT_MS = 60_000;
const BACKOFF_MS = [2000, 3000, 5000, 8000, 8000, 8000, 8000, 8000, 5000];
const SIGNUP_NEW_PATH = '/signup=new';

const RegisterPreparing = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { user_exists } = useSelector<ApplicationState, RegisterState>(
    (state) => state.session.register,
  );

  const email = sessionStorage.getItem('register_preparing_email') || undefined;
  const password = sessionStorage.getItem('register_preparing_password') || undefined;

  const didLoginAttemptRef = useRef(false);
  const didRedirectRef = useRef(false);
  const timeoutRef = useRef<number | null>(null);

  const clearPollTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const redirectTo = (path: string) => {
    if (didRedirectRef.current) return;
    didRedirectRef.current = true;
    clearPollTimer();
    sessionStorage.removeItem('register_preparing_email');
    sessionStorage.removeItem('register_preparing_password');
    history.replace(path);
  };

  useEffect(() => {
    document.title = 'Cadastro - Conlicitação';

    if (!email) {
      console.warn('[RegisterPreparing] sem email no sessionStorage -> redirect /cadastro_novo');
      history.replace('/cadastro_novo');
      return;
    }

    const startedAt = Date.now();
    let attempt = 0;

    const scheduleNext = () => {
      if (didLoginAttemptRef.current || didRedirectRef.current) return;

      const elapsed = Date.now() - startedAt;
      if (elapsed >= TIMEOUT_MS) {
        redirectTo(SIGNUP_NEW_PATH);
        return;
      }

      const delay = BACKOFF_MS[Math.min(attempt, BACKOFF_MS.length - 1)];
      attempt += 1;

      timeoutRef.current = window.setTimeout(() => {
        if (didLoginAttemptRef.current || didRedirectRef.current) return;
        dispatch(userExists(email));
        scheduleNext();
      }, delay);
    };

    dispatch(userExists(email));
    scheduleNext();

    return () => clearPollTimer();
  }, [dispatch, history, email]);

  useEffect(() => {
    if (user_exists !== true) return;
    if (didLoginAttemptRef.current) return;

    if (!email || !password) {
      console.warn('[RegisterPreparing] user_exists true mas faltou email/password', {
        email,
        passwordExists: Boolean(password),
      });
      return;
    }

    didLoginAttemptRef.current = true;
    clearPollTimer();

    (async () => {
      try {
        await dispatch(profileSignIn({ login: email, senha: password, tabId: tabId() }));
        redirectTo('/');
      } catch (err) {
        console.warn('[RegisterPreparing] login automático falhou', err);
        redirectTo(SIGNUP_NEW_PATH);
      }
    })();
  }, [user_exists, email, password, dispatch]);

  return (
    <RegisterStatusCard
      title="Estamos personalizando a sua experiência!"
      subtitle="Só um instante… estamos preparando seu acesso."
    >
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 8 }}>
        <div className="spinner-border text-success" role="status" aria-label="Carregando" />
      </div>

      <small className="support-hours" style={{ display: 'block', marginTop: 14 }}>
        Se isso demorar, entre em contato com o suporte.
      </small>
    </RegisterStatusCard>
  );
};

export default RegisterPreparing;
